import { render, staticRenderFns } from "./registerSelect.vue?vue&type=template&id=ed1abfd2&scoped=true&"
import script from "./registerSelect.vue?vue&type=script&lang=js&"
export * from "./registerSelect.vue?vue&type=script&lang=js&"
import style0 from "./registerSelect.vue?vue&type=style&index=0&id=ed1abfd2&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed1abfd2",
  null
  
)

export default component.exports